class HelperMenu extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.setupEventListeners();
    this.setupKeyboardNavigation();
  }

  setupEventListeners() {
    // Close button
    const closeBtn = this.querySelector('.helper-menu-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close());
    }

    // Overlay click
    const overlay = this.querySelector('.helper-menu-overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.close());
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Prevent body scroll when menu is open
    this.observer = new MutationObserver(() => {
      if (this.isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });

    this.observer.observe(this, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  setupKeyboardNavigation() {
    const links = this.querySelectorAll('.helper-menu-link');
    links.forEach((link, index) => {
      link.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const nextLink = links[index + 1] || links[0];
          nextLink.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prevLink = links[index - 1] || links[links.length - 1];
          prevLink.focus();
        }
      });
    });
  }

  open() {
    this.classList.add('active');
    this.isOpen = true;
    this.setAttribute('aria-hidden', 'false');
    
    // Focus first link
    const firstLink = this.querySelector('.helper-menu-link');
    if (firstLink) {
      setTimeout(() => firstLink.focus(), 100);
    }
  }

  close() {
    this.classList.remove('active');
    this.isOpen = false;
    this.setAttribute('aria-hidden', 'true');
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
}

customElements.define('helper-menu', HelperMenu);

// Global function to open helper menu
window.openHelperMenu = function() {
  const menu = document.getElementById('helperMenuPopup');
  if (menu) {
    menu.open();
  }
};

// Global function to close helper menu
window.closeHelperMenu = function() {
  const menu = document.getElementById('helperMenuPopup');
  if (menu) {
    menu.close();
  }
};

